// Home, escolha de liga e escolha de clube.
//
// O desenho e o do 38 Brasil, tela por tela: marca centralizada, "kicker" em
// caixa alta, titulo grande, um CTA principal que ocupa a largura toda com
// titulo e subtitulo, cartoes de modo abaixo, o cartao do premium com as
// funcoes em grade e o preco em destaque, e o rodape de links.

import React, { useMemo, useState } from 'react';
import { newLeague } from '../engine/career.js';
import { LEAGUE_LIST, playoffSize } from '../data/leagues.js';
import { payrollOf, econOf, money } from '../engine/economy.js';
import { Toasts, Ovr } from './ui.jsx';
import { Ball } from './logo.jsx';
import { Flag } from './flags.jsx';
import { Crest } from './crest.jsx';
import { PREMIUM, isLeagueFree } from './premium-config.js';
import { PlayStoreCta, AvaliarCta } from './play-store.jsx';

function Topbar({ right, onBack, onAccount, account }) {
  return (
    <div className="topbar">
      <div className="inner">
        <div className="row" style={{ gap: 8 }}>
          {onBack && <button className="ghost sm" onClick={onBack}>voltar</button>}
          {onAccount && !onBack && (
            <button className="ghost sm" onClick={onAccount}>
              {account ? account.email.split('@')[0] : 'Entrar / Criar'}
            </button>
          )}
          <div className="brand">82 <b>Basquete</b></div>
        </div>
        <div className="meta">{right}</div>
      </div>
    </div>
  );
}

function teamStrength(team) {
  const top8 = [...team.roster].sort((a, b) => b.overall - a.overall).slice(0, 8);
  return Math.round(top8.reduce((a, p) => a + p.overall, 0) / top8.length);
}

function outlook(strength, all) {
  const sorted = [...all].sort((a, b) => b - a);
  const rank = sorted.indexOf(strength) + 1;
  const size = all.length;
  if (rank <= Math.max(3, size * 0.17)) return { text: 'Candidato ao titulo', cls: 'pos' };
  if (rank <= size * 0.5) return { text: 'Briga por playoffs', cls: 'muted' };
  if (rank <= size * 0.8) return { text: 'Fora dos playoffs', cls: 'warn' };
  return { text: 'Reconstrucao', cls: 'neg' };
}

// ================================================================== HOME ===
export function Home({
  hasSave, saveInfo, onContinue, onNew, onDelete, onHowTo, onPremium, onAccount,
  account, premium, toasts, telaInicial, enquete, onVotar,
  onDesafio, desafioEmAndamento, onRetomarDesafio, onBug, temporadasFechadas,
  sessaoEncerrada, onEntrar,
}) {
  return (
    <>
      <Topbar right="" onAccount={onAccount} account={account} />
      <div className="wrap home">
        <div className="home-brand">
          <Ball size={58} />
          <p className="kicker">• Modo treinador</p>
          <h1 className="home-title">82 <b>Basquete</b></h1>
          <p className="home-sub">Elenco, rotacao e mercado — o time e seu.</p>
        </div>

        {/* A sessao foi derrubada por um login em outro aparelho. Fica ate a
            pessoa entrar de novo -- ver o comentario em App.jsx. */}
        {sessaoEncerrada && (
          <div className="home-recado">
            <div className="t">Sua conta foi aberta em outro aparelho</div>
            <div className="d">
              Por seguranca, so uma sessao fica ativa por conta. Sua carreira
              neste aparelho esta intacta — entre de novo para voltar a usar o
              save na nuvem.
            </div>
            <button className="primary sm" style={{ marginTop: 9 }} onClick={onEntrar}>
              Entrar de novo
            </button>
          </div>
        )}

        {telaInicial && (
          <div className="home-recado">
            {telaInicial.titulo && <div className="t">{telaInicial.titulo}</div>}
            <div className="d">{telaInicial.texto}</div>
          </div>
        )}

        {/* A enquete pede conta porque o voto e um por pessoa. Sem conta nao
            da para impedir que a mesma pessoa vote dez vezes, e ai o resultado
            nao serve para decidir nada. */}
        {enquete && account && (
          <div className="card">
            <p className="kicker">• Sua opiniao</p>
            <h3 style={{ marginTop: 2 }}>{enquete.pergunta}</h3>
            <div className="grid" style={{ gap: 7, marginTop: 8 }}>
              {enquete.opcoes.map((o, i) => (
                <button key={o} className={enquete.meuVoto === i ? 'club on' : 'club'}
                  onClick={() => onVotar(i)}>
                  <div className="row spread">
                    <span className="nm">{o}</span>
                    {enquete.meuVoto === i && <span className="pill on">seu voto</span>}
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* ⚠️ O relato fica AQUI, ao lado de "Como jogar" e do premium, e nao
            no rodape. No rodape ele existia mas ninguem rolava ate ele -- e um
            relato que nao chega e o mesmo que defeito nao descoberto.
            So aparece para quem tem conta: o servidor aceita relato anonimo de
            proposito (quem nao consegue entrar ainda precisa avisar), mas
            relato sem e-mail nao tem como ser respondido, e responder e metade
            do valor de receber. */}
        <div className="home-links">
          <button onClick={onHowTo}>Como jogar</button>
          <button onClick={onPremium}>{premium ? 'Premium ativo' : PREMIUM.name}</button>
          {onBug && <button onClick={onBug}>Relatar problema</button>}
        </div>

        {hasSave && (
          <button className="cta" onClick={onContinue}>
            <span className="ic">▶</span>
            <span>
              <span className="tt">Continuar carreira</span>
              <span className="ss">
                {saveInfo.teamName} · {saveInfo.leagueName} · temporada {saveInfo.season}
                {saveInfo.phase === 'regular' && ` · rodada ${saveInfo.round} · ${saveInfo.record}`}
                {saveInfo.phase === 'playoffs' && ' · playoffs'}
                {saveInfo.phase === 'draft' && ' · draft'}
                {saveInfo.phase === 'offseason' && ' · entressafra'}
              </span>
            </span>
            <span className="arrow">›</span>
          </button>
        )}

        <button className={hasSave ? 'cta dark' : 'cta'} onClick={onNew}>
          <span className="ic">🏆</span>
          <span>
            <span className="tt">{hasSave ? 'Comecar outra carreira' : 'Comecar carreira'}</span>
            <span className="ss">NBB ou NBA · temporada, playoffs e draft na 1a temporada</span>
          </span>
          <span className="arrow">›</span>
        </button>

        {/* O desafio da semana vem logo depois da carreira, e antes do
            premium: e a unica coisa do jogo que muda toda segunda, e a razao
            de alguem voltar sem ter carreira em andamento.

            ⚠️ SO PARA QUEM TEM CONTA. O cartao continua APARECENDO para quem
            nao tem -- ele e o motivo de criar a conta, e escondido nao
            convence ninguem de nada. Quem toca sem estar logado cai no
            cadastro, nao num aviso de erro. A regra de verdade esta no
            servidor (`/api/desafio`); isto aqui e so o convite. */}
        <button
          className="cta dark desafio-cta"
          onClick={!account ? onEntrar : (desafioEmAndamento ? onRetomarDesafio : onDesafio)}
        >
          <span className="ic">🗓️</span>
          <span>
            <span className="tt">
              {!account ? 'Desafio da semana'
                : desafioEmAndamento ? 'Continuar o desafio' : 'Desafio da semana'}
            </span>
            <span className="ss">
              {!account
                ? 'todo mundo joga a mesma liga · entre para jogar, e gratis'
                : desafioEmAndamento
                  ? 'voce parou no meio — o ranking fecha domingo'
                  : 'todo mundo joga a mesma liga · 10 rodadas · gratis'}
            </span>
          </span>
          <span className="arrow">›</span>
        </button>

        {/* Logo abaixo do "Comecar carreira", que e onde o olho ja esta.
            Some sozinho para quem ja esta dentro do app, e enquanto a ficha da
            Play nao estiver publica. Ver src/app/play-store.jsx. */}
        <PlayStoreCta />

        {/* Pedido de avaliacao: so dentro do app e so para quem ja fechou uma
            temporada. As travas estao em src/app/play-store.jsx. */}
        <AvaliarCta temporadasFechadas={temporadasFechadas} />

        {hasSave && (
          <div className="center">
            <button className="danger sm" onClick={onDelete}>apagar carreira</button>
          </div>
        )}

        <div className="card">
          <h3>O que da para jogar</h3>
          <div className="row spread">
            <div className="row" style={{ gap: 6 }}>
              <span className="pill">2 ligas</span>
              <span className="pill">62 times</span>
              <span className="pill">draft</span>
            </div>
            <span className="pill gold">{PREMIUM.priceLabel}</span>
          </div>
        </div>

        {!premium && (
          <div className="pitch">
            <div className="row spread" style={{ marginBottom: 6 }}>
              <span className="tag">opcional</span>
              <div className="price">
                <span className="v">{PREMIUM.priceLabel}</span>
                <span className="u">{PREMIUM.kind}</span>
              </div>
            </div>
            <div style={{ fontSize: 18, fontWeight: 800, letterSpacing: '-.02em' }}>
              {PREMIUM.name}
            </div>
            <div className="muted small" style={{ marginTop: 3 }}>{PREMIUM.pitch}</div>
            <div className="feature-grid">
              {PREMIUM.features.map((f) => <span key={f}>{f}</span>)}
            </div>
            <button className="primary" style={{ width: '100%' }} onClick={onPremium}>
              Assinar · {PREMIUM.priceLabel}
            </button>
            <div className="dim small center" style={{ marginTop: 8 }}>
              O NBB e gratis e completo. O premium e um Pix so, sem mensalidade.
            </div>
          </div>
        )}

        <button className="cta dark" onClick={onHowTo}>
          <span className="ic">📘</span>
          <span>
            <span className="tt">Como jogar</span>
            <span className="ss">Recomendado antes da 1a partida</span>
          </span>
          <span className="arrow">›</span>
        </button>

        <div className="site-foot">
          <button onClick={onHowTo}>Como jogar</button>·
          <button onClick={onPremium}>{PREMIUM.name}</button>·
          <button onClick={onAccount}>Conta</button>·
          {/* Pagina solta, fora do bundle: a Play Store exige um endereco de
              politica de privacidade que responda sozinho. Por isso e <a> de
              verdade, e nao mais uma tela do React. */}
          <a href="privacidade" target="_blank" rel="noreferrer">Privacidade</a>
          <div style={{ marginTop: 6 }}>
            82 Basquete — jogo independente de modo treinador.<br />
            Times e elencos reais das duas ligas.
          </div>
        </div>
      </div>
      <Toasts items={toasts || []} />
    </>
  );
}

// ========================================================= ESCOLHER A LIGA ==
export function LeaguePicker({ onPick, onBack, premium, onPremium }) {
  return (
    <>
      <Topbar right="Nova carreira · 1 de 2" onBack={onBack} />
      <div className="wrap">
        <p className="kicker" style={{ marginBottom: 8 }}>• Passo 1</p>
        <h1 style={{ marginBottom: 14 }}>Em qual liga voce quer treinar?</h1>

        <div className="grid" style={{ gap: 12 }}>
          {LEAGUE_LIST.map((config) => {
            const econ = econOf(config);
            const free = isLeagueFree(config.id);
            const locked = !free && !premium;
            return (
              <button
                key={config.id}
                className={locked ? 'club' : 'club'}
                onClick={() => (locked ? onPremium() : onPick(config.id))}
                style={locked ? { opacity: .92 } : undefined}
              >
                <div className="row spread" style={{ marginBottom: 6 }}>
                  <span className="row" style={{ gap: 8, fontSize: 19, fontWeight: 800, letterSpacing: '-.02em' }}>
                    <Flag code={config.flagCode} size={22} title={config.country} />
                    {config.name}
                  </span>
                  {free
                    ? <span className="tag">gratis</span>
                    : <span className="pill gold">{premium ? 'liberado' : PREMIUM.priceLabel}</span>}
                </div>
                <div className="small muted" style={{ marginBottom: 10 }}>{config.blurb}</div>
                <div className="grid two small">
                  <div className="row spread">
                    <span className="dim">Temporada</span><b>{config.regularRounds} rodadas</b>
                  </div>
                  <div className="row spread">
                    <span className="dim">Playoffs</span><b>{playoffSize(config)} times</b>
                  </div>
                  <div className="row spread">
                    <span className="dim">Teto salarial</span><b>{money(econ.salaryCap)}</b>
                  </div>
                  <div className="row spread">
                    <span className="dim">Elenco</span><b>{econ.minRoster} a {econ.maxRoster}</b>
                  </div>
                </div>
                {locked && (
                  <div className="small acc" style={{ marginTop: 9, fontWeight: 700 }}>
                    Abre com o {PREMIUM.name} · toque para ver ›
                  </div>
                )}
              </button>
            );
          })}
        </div>

        <div className="dim small" style={{ marginTop: 14, marginBottom: 30 }}>
          A liga define o formato, o dinheiro e o tamanho do elenco. No NBB cada
          contratacao pesa muito mais no orcamento.
        </div>
      </div>
    </>
  );
}

// ========================================================= ESCOLHER O CLUBE =
export function ClubPicker({ leagueId, onCreate, onBack }) {
  const [seed, setSeed] = useState(() => String(Date.now()));
  const [clubId, setClubId] = useState(null);
  const [coachName, setCoachName] = useState('');
  const [filter, setFilter] = useState('todos');

  const league = useMemo(() => newLeague(leagueId, seed), [leagueId, seed]);
  const config = useMemo(
    () => LEAGUE_LIST.find((l) => l.id === leagueId) || LEAGUE_LIST[0],
    [leagueId],
  );
  const strengths = league.teams.map(teamStrength);
  const selected = league.teams.find((t) => t.id === clubId);
  const conferences = config.conferences || [];

  const filters = [
    ['todos', 'Todos'],
    ['fortes', 'Candidatos'],
    ['desafio', 'Desafio'],
    ...conferences.map((c) => [c.toLowerCase(), c]),
  ];

  const shown = league.teams
    .map((t, i) => ({ team: t, strength: strengths[i] }))
    .filter(({ team, strength }) => {
      if (filter === 'fortes') return outlook(strength, strengths).cls === 'pos';
      if (filter === 'desafio') return ['warn', 'neg'].includes(outlook(strength, strengths).cls);
      if (conferences.some((c) => c.toLowerCase() === filter)) {
        return team.conference.toLowerCase() === filter;
      }
      return true;
    })
    .sort((a, b) => b.strength - a.strength);

  return (
    <>
      <Topbar right={`${config.name} · 2 de 2`} onBack={onBack} />
      <div className="wrap">
        <div className="card">
          <h3>Seu nome</h3>
          <input
            value={coachName}
            onChange={(e) => setCoachName(e.target.value)}
            placeholder="Como quer ser chamado"
            maxLength={28}
          />
        </div>

        <h1 style={{ fontSize: 17, marginBottom: 10 }}>Escolha o clube</h1>

        <div className="row wrap" style={{ gap: 6, marginBottom: 12 }}>
          {filters.map(([id, label]) => (
            <button key={id} className={`sm ${filter === id ? 'primary' : 'ghost'}`} onClick={() => setFilter(id)}>
              {label}
            </button>
          ))}
        </div>

        <div className="grid two">
          {shown.map(({ team, strength }) => {
            const look = outlook(strength, strengths);
            const payroll = payrollOf(team.roster);
            const star = [...team.roster].sort((a, b) => b.overall - a.overall)[0];
            return (
              <button
                key={team.id}
                className={`club ${clubId === team.id ? 'on' : ''}`}
                onClick={() => setClubId(team.id)}
              >
                <div className="club-head">
                  <Crest team={team} size={28} />
                  <Ovr value={strength} />
                </div>
                <div className="nm">{team.name}</div>
                <div className={`small ${look.cls}`}>
                  {look.text}{config.conferences ? ` · ${team.conference}` : ''}
                </div>
                <div className="small dim" style={{ marginTop: 5 }}>
                  {star.name} ({star.overall})
                </div>
                <div className="small dim">
                  Caixa {money(team.money)} · folha {money(payroll)}
                </div>
              </button>
            );
          })}
        </div>

        {selected && (
          <div style={{ position: 'sticky', bottom: 12, marginTop: 14 }}>
            <button
              className="cta"
              onClick={() => onCreate({ league, clubId, coachName: coachName.trim() || 'Tecnico' })}
            >
              <span className="ic">🏀</span>
              <span>
                <span className="tt">Assumir o {selected.name}</span>
                <span className="ss">{config.regularRounds} rodadas pela frente</span>
              </span>
              <span className="arrow">›</span>
            </button>
          </div>
        )}
        <div style={{ height: 30 }} />
      </div>
    </>
  );
}
